import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57668cd1")

_pushScopeId("data-v-57668cd1")
const _hoisted_1 = { class: "select-list-main-container" }
const _hoisted_2 = { class: "select-list-group" }
const _hoisted_3 = {
  class: "select-list-label",
  for: "select-list"
}
const _hoisted_4 = { class: "select-list-label-desc" }
const _hoisted_5 = { class: "select-list-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("label", _hoisted_3, [
        _createVNode("strong", null, _toDisplayString(_ctx.header), 1),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.description), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedValueInternal = $event)),
          required: ""
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectData, (type, index) => {
            return (_openBlock(), _createBlock("option", {
              key: index,
              value: type
            }, _toDisplayString(type.display_name), 9, ["value"]))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedValueInternal]
        ])
      ])
    ])
  ]))
})